module.exports = __webpack_public_path__ + "static/logo-draw-75816422697c8c66dbce4e3ad16960df.svg";